module.exports = __webpack_public_path__ + "images/psp/SizeGuide/light-protection.svg";